//src/app/(site)/vouchers/offer/[offerId]/OfferClient.tsx
"use client";
import { useEffect, useState, useMemo } from "react";
import SelectedProductSummary from "@/components/SelectedProductSummary";
import { useAuth } from "@/context/AuthContext";
import { usePiSocketCtx } from "@/context/PiSocketContext";

export default function OfferClient({ product }: { product: any }) {
  const { user } = useAuth();
  const { piRate, feePercent, basePI, totalPI, requestPriceUpdate } = usePiSocketCtx();
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  const priceUSD = useMemo(() => {
    return product?.price?.fixed ? product.price.fixed / 100 : null;
  }, [product]);

  useEffect(() => {
    if (!mounted) return;
    if (!product?.offerId) return;
    const usd = Number(priceUSD);
    if (!Number.isFinite(usd) || usd <= 0) return;
    requestPriceUpdate?.(usd, product.offerId);
  }, [mounted, priceUSD, product?.offerId, requestPriceUpdate]);

  return (
    <SelectedProductSummary
      product={product}
      priceUSD={priceUSD}
      piRate={mounted ? piRate : undefined}
      basePI={mounted ? basePI : undefined}
      totalPI={mounted ? totalPI : undefined}
      feePercent={mounted ? feePercent : undefined}
      user={user}
    />
  );
}
